<template>
  <div>
    <div>
      <el-row v-if="currentGame">
        <el-col :span="6">Текущая игра</el-col>
        <el-col :span="18">
          <router-link :to="`/admin/games/${currentGame.id}`">{{currentGame.name}}</router-link>
        </el-col>
      </el-row>
      <hr />
      <h3>Игры</h3>
      <el-button @click="$router.push('/admin/createGame')" type="primary">Создать новую игру</el-button>
      <ul>
      <li v-for="game in games" :key="game.id">
        <router-link :to="`/admin/games/${game.id}`">{{game.name}}</router-link>
      </li>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Admin',
  computed: {
    currentGame() {
      return this.$store.state.currentGame;
    },
    games() {
      return this.$store.state.games;
    }
  }
}
</script>
